import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-count", "data-index"]
const _hoisted_2 = { class: "img-slider-content" }
const _hoisted_3 = { ref: "sliderWrapper" }
const _hoisted_4 = ["src", "data-index"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["img-slider", [_ctx.aspect]]),
    "data-count": _ctx.images.length,
    "data-index": _ctx.imageIndex
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageUrls, (imageUrl, index) => {
          return (_openBlock(), _createElementBlock("picture", { key: index }, [
            _createElementVNode("img", {
              src: imageUrl,
              "data-index": index,
              alt: ""
            }, null, 8, _hoisted_4)
          ]))
        }), 128))
      ], 512)
    ]),
    (_ctx.imageIndex > 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "prev-btn",
          title: _ctx.pageTexts['hotelPageNavigationButtonPrevious'],
          hidden: "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousImage && _ctx.previousImage(...args)))
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.imageIndex < _ctx.images.length - 1)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "next-btn",
          title: _ctx.pageTexts['hotelPageNavigationButtonNext'],
          hidden: "",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextImage && _ctx.nextImage(...args)))
        }, null, 8, _hoisted_6))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}